<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-card-title>
          <v-row>
            <v-col cols="12" sm="6" md="3">
              <v-autocomplete
                outlined
                flat
                dense
                :items="dropdownYear"
                item-text="name"
                item-value="year"
                background-color="white"
                v-model="year"
                @change="onChangeYear"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3" class="text-right">
              <v-btn v-if="$rbac.can('report.export')" @click="excel" color="success">
                <v-icon left>
                  mdi-file-excel
                </v-icon>
                Export Excel
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :items-per-page="10"
            :footer-props="{
              'items-per-page-options': [5, 10, 25, 50, 100, -1],
            }"
            class="elevation-1"
            dense
          >
            <template v-slot:item.no="{ item }">
              {{ items.indexOf(item) + 1 }}
            </template>
            <template v-slot:item.invoices="{ item }">
              <ul v-if="item.invoices.length > 0">
                <li v-for="(data, index) in item.invoices" :key="index">
                  {{ data.invoiceNumber }}
                </li>
              </ul>
              <p v-else>No Invoices</p>
            </template>
            <template v-slot:item.poAmount="{ item }">
              <span class="clickable-cell" @click="openDetail(item, 'PO_AMOUNT')">
                {{ formatPrice(item.poAmount) }}
              </span>
            </template>
            <template v-slot:item.marginEstimation="{ item }">
              <span class="clickable-cell" @click="openDetail(item, 'MARGIN_ESTIMATION')">
                {{ formatPercentage(item.marginEstimation) }}
              </span>
            </template>
            <template v-slot:item.marginActual="{ item }">
              <span class="clickable-cell" @click="openDetail(item, 'MARGIN_ACTUAL')">
                {{ formatPercentage(item.marginActual) }}
              </span>
            </template>
            <template v-slot:item.variance="{ item }">
              <span class="clickable-cell" @click="openDetail(item, 'VARIANCE')">
                {{ formatPercentage(item.variance) }}
              </span>
            </template>
            <template v-slot:item.totalEstimation="{ item }">
              <span class="clickable-cell" @click="openDetail(item, 'TOTAL_ESTIMATION')">
                {{ formatPrice(item.totalEstimation) }}
              </span>
            </template>
            <template v-slot:item.totalActual="{ item }">
              <span class="clickable-cell" @click="openDetail(item, 'TOTAL_ACTUAL')">
                {{ formatPrice(item.totalActual) }}
              </span>
            </template>
            <template v-slot:item.varianceAmount="{ item }">
              <span class="clickable-cell" @click="openDetail(item, 'VARIANCE_AMOUNT')">
                {{ formatPrice(item.varianceAmount) }}
              </span>
            </template>
            <!--            <template v-slot:body.append>-->
            <!--              <tr class="font-weight-bold grey lighten-3">-->
            <!--                <td colspan="2" class="text-center">Total</td>-->
            <!--                <td class="text-right">{{ formatPrice(totalPoAmount) }}</td>-->
            <!--                <td class="text-right">{{ formatPercentage(totalMarginEstimation) }}</td>-->
            <!--                <td class="text-right">{{ formatPercentage(totalMarginActual) }}</td>-->
            <!--                <td class="text-right">{{ formatPercentage(totalVariance) }}</td>-->
            <!--                <td class="text-right">{{ formatPrice(totalEstimation) }}</td>-->
            <!--                <td class="text-right">{{ formatPrice(totalActual) }}</td>-->
            <!--                <td class="text-right">{{ formatPrice(totalVarianceAmount) }}</td>-->
            <!--              </tr>-->
            <!--            </template>-->
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>

    <!-- Modal Detail Margin -->
    <v-dialog v-model="dialogDetail" max-width="1000px" scrollable>
      <v-card>
        <v-card-title class="headline grey lighten-2 py-3 px-4">
          <v-icon left color="primary">mdi-format-list-bulleted</v-icon>
          Rincian: {{ detailTitle }}
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogDetail = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-4">
          <v-row v-if="detailSummary" class="mb-4 bg-light pa-2 rounded border mx-0">
            <v-col cols="12" sm="4">
              <div class="grey--text text--darken-1 caption text-uppercase">PO Number</div>
              <div class="subtitle-1 font-weight-bold primary--text">
                {{ detailSummary.poNumber }}
              </div>
            </v-col>
            <v-col cols="12" sm="4">
              <div class="grey--text text--darken-1 caption text-uppercase">Customer</div>
              <div class="subtitle-1 font-weight-bold">{{ detailSummary.customer }}</div>
            </v-col>
            <v-col cols="12" sm="4" class="text-right">
              <div class="grey--text text--darken-1 caption text-uppercase">Nilai Cell</div>
              <div class="subtitle-1 font-weight-bold">
                {{ formatDetailSummaryValue(detailSummary) }}
              </div>
            </v-col>
          </v-row>

          <v-data-table
            :headers="detailHeaders"
            :items="detailItems"
            :loading="loadingDetail"
            :page.sync="detailPage"
            :items-per-page.sync="detailItemsPerPage"
            dense
            fixed-header
            height="500px"
            class="elevation-1 border"
            :no-data-text="'Tidak ada rincian data'"
            :footer-props="{
              'items-per-page-options': [10, 25, 50, 100],
            }"
          >
            <template v-slot:item.amount="{ item }">
              <span :class="item.amount < 0 ? 'red--text' : ''">
                {{ formatPrice(item.amount) }}
              </span>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="py-2 px-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogDetail = false">Tutup</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import api from "@/services/api";
import fileDownload from "js-file-download";

export default {
  name: "report-margin-summary",
  data() {
    return {
      search: "",
      items: [],
      dialogDetail: false,
      loadingDetail: false,
      detailTitle: "",
      detailItems: [],
      detailSummary: null,
      detailPage: 1,
      detailItemsPerPage: 10,
      detailHeaders: [
        { text: "Tgl Transaksi", value: "date", align: "start" },
        { text: "No. Dokumen", value: "number" },
        { text: "Keterangan", value: "description" },
        { text: "Tipe", value: "type" },
        { text: "Nilai (IDR)", value: "amount", align: "right" },
      ],
      headers: [
        {
          text: "No",
          value: "no",
          align: "center",
          sortable: false,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "Customer",
          value: "customer",
          align: "center",
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "PO Number",
          value: "poNumber",
          align: "center",
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "Invoices",
          value: "invoices",
          align: "center",
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "PO Amount",
          value: "poAmount",
          align: "right",
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "Margin Estimation",
          value: "marginEstimation",
          align: "right",
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "Margin Actual",
          value: "marginActual",
          align: "right",
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "Variance",
          value: "variance",
          align: "right",
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "Total Estimation",
          value: "totalEstimation",
          align: "right",
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "Total Actual",
          value: "totalActual",
          align: "right",
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          text: "Variance Amount",
          value: "varianceAmount",
          align: "right",
          class: "light-blue lighten-2 font-weight-black",
        },
      ],
      year: new Date().getFullYear(),
    };
  },
  computed: {
    totalPoAmount() {
      if (this.items.length > 0) {
        return this.items.map(x => x.poAmount || 0).reduce((total, current) => total + current);
      }
      return 0;
    },
    totalMarginEstimation() {
      if (this.items.length > 0) {
        return this.items
          .map(x => x.marginEstimation || 0)
          .reduce((total, current) => total + current);
      }
      return 0;
    },
    totalMarginActual() {
      if (this.items.length > 0) {
        return this.items.map(x => x.marginActual || 0).reduce((total, current) => total + current);
      }
      return 0;
    },
    totalVariance() {
      if (this.items.length > 0) {
        return this.items.map(x => x.variance || 0).reduce((total, current) => total + current);
      }
      return 0;
    },
    totalEstimation() {
      if (this.items.length > 0) {
        return this.items
          .map(x => x.totalEstimation || 0)
          .reduce((total, current) => total + current);
      }
      return 0;
    },
    totalActual() {
      if (this.items.length > 0) {
        return this.items.map(x => x.totalActual || 0).reduce((total, current) => total + current);
      }
      return 0;
    },
    totalVarianceAmount() {
      if (this.items.length > 0) {
        return this.items
          .map(x => x.varianceAmount || 0)
          .reduce((total, current) => total + current);
      }
      return 0;
    },
    dropdownYear() {
      const year = new Date().getFullYear();
      let result = [{ name: "All", year: 0 }];
      for (let i = 0; i <= 3; i++) {
        const fixYear = year - i;
        result.push({
          name: "" + fixYear,
          year: fixYear,
        });
      }
      return result;
    },
  },
  methods: {
    initialize() {
      this.getReport(this.year);
    },
    formatPrice(value) {
      if (value === null || value === undefined) {
        return "-";
      }
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatPercentage(value) {
      if (value === null || value === undefined) {
        return "-";
      }
      return `${(value / 1).toFixed(2)}%`;
    },
    formatDetailSummaryValue(summary) {
      if (!summary) {
        return "-";
      }
      return summary.percentage
        ? this.formatPercentage(summary.value)
        : this.formatPrice(summary.value);
    },
    async excel() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("report/marginSummaryExcel", { year: this.year })
        .then(response => {
          fileDownload(response.data, `report-margin-summary.xlsx`);
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    onChangeYear(val) {
      this.getReport(val);
    },
    async openDetail(item, category) {
      const labels = {
        PO_AMOUNT: "PO Amount",
        MARGIN_ESTIMATION: "Margin Estimation",
        MARGIN_ACTUAL: "Margin Actual",
        VARIANCE: "Variance",
        TOTAL_ESTIMATION: "Total Estimation",
        TOTAL_ACTUAL: "Total Actual",
        VARIANCE_AMOUNT: "Variance Amount",
      };
      const valueMap = {
        PO_AMOUNT: item.poAmount,
        MARGIN_ESTIMATION: item.marginEstimation,
        MARGIN_ACTUAL: item.marginActual,
        VARIANCE: item.variance,
        TOTAL_ESTIMATION: item.totalEstimation,
        TOTAL_ACTUAL: item.totalActual,
        VARIANCE_AMOUNT: item.varianceAmount,
      };

      this.detailTitle = `${labels[category] || category} - ${item.poNumber}`;
      this.detailSummary = {
        poNumber: item.poNumber,
        customer: item.customer || "-",
        value: valueMap[category],
        percentage: ["MARGIN_ESTIMATION", "MARGIN_ACTUAL", "VARIANCE"].includes(category),
      };
      this.dialogDetail = true;
      this.loadingDetail = true;
      this.detailPage = 1;
      this.detailItems = [];

      try {
        const res = await api.post("/reports/margin/summary/detail", {
          category: category,
          poNumber: item.poNumber,
          year: this.year,
        });

        this.detailItems = res.data.map(x => ({
          date: x.date || "-",
          number: x.number || "-",
          description: x.description || "-",
          type: x.type || "-",
          amount: x.amount || 0,
        }));
      } catch (e) {
        this.$store.dispatch("toast", { type: "error", message: "Gagal memuat detail" });
      } finally {
        this.loadingDetail = false;
      }
    },
    async getReport(year) {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("report/marginSummary", { year: year })
        .then(response => {
          // Map response data to match the table structure
          this.items = response.data.map(item => ({
            poNumber: item.poNumber,
            poAmount: item.totalPo || 0,
            marginEstimation: item.marginEstimation ? item.marginEstimation.marginPercentage : 0,
            marginActual: item.marginActual ? item.marginActual.marginPercentage : 0,
            variance: item.variance || 0,
            totalEstimation: item.marginEstimation ? item.marginEstimation.total : 0,
            totalActual: item.marginActual ? item.marginActual.total : 0,
            varianceAmount: item.varianceAmount || 0,
            customer: item.customer,
            invoices: item.invoices,
          }));
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
  },
  mounted() {
    this.initialize();
  },
};
</script>

<style scoped>
.clickable-cell {
  cursor: pointer;
  color: #1976d2;
  text-decoration: underline;
  font-weight: 500;
  display: inline-block;
}
.clickable-cell:hover {
  background-color: #f5f5f5;
  padding: 2px 4px;
  border-radius: 4px;
}
.bg-light {
  background-color: #f8f9fa;
}
</style>
